// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8645ef05","729":"471cdc5f"}[chunkId] + ".chunk.js";
};